import React from "react";

import { Grid, Stack, useTheme } from "@mui/material";

import TitleBox from "./components/TitleBox";

const GridBox = ({ style = {}, size, title, tooltip, body }) => {
  const theme = useTheme();

  const mergedStyle = {
    p: 2,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 5,
    ...style,
  };

  return (
    <Grid item xs={size?.xs} sm={size?.sm} md={size?.md} sx={mergedStyle}>
      <Stack gap={2} justifyContent="center" alignItems="center">
        <TitleBox title={title} tooltip={tooltip} />
        <div>{body}</div>
      </Stack>
    </Grid>
  );
};

export default GridBox;
